import { combineReducers } from 'redux'

import { navigationReducer } from '../components/Navigations/state'
import { feedbackReducer } from '../components/Feedback/state'

export default combineReducers({
  navigation: navigationReducer,
  feedback: feedbackReducer
})
